import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { GeneralUtilsService } from './../../common/_services/common/generalUtils.service';
import { ThemeConfig } from './../../../assets/data/enum/themeConfig';
import { ThemeService } from '../../common/_theme/theme.service';
import { SAASBRANDNAME } from '../../../assets/data/enum/saasBrandName.enum';

@Component({
  selector: 'app-download-app-overlay',
  templateUrl: './download-app-overlay.component.html',
  styleUrls: ['./download-app-overlay.component.css'],
  standalone: false,
})
export class DownloadAppOverlayComponent implements OnInit {
  showOverlay = false;
  themeConfig = ThemeConfig;
  backgroundUrl = '';
  logoLoginUrl = '';
  mobileScreeAPP = '';
  brand = SAASBRANDNAME;

  constructor(
    private translate: TranslateService,
    private generalUtilsService: GeneralUtilsService,
    private themeService: ThemeService
  ) {
    this.backgroundUrl = this.themeService.getValueFromConfigurationThemeByKey('backgroundUrl');
    this.logoLoginUrl = this.themeService.getValueFromConfigurationThemeByKey('logoLoginUrl');
    this.mobileScreeAPP = this.themeService.getValueFromConfigurationThemeByKey('mobileScreeAPP');
  }

  ngOnInit(): void {
    // check if the download app banner is to show or not
    if (
      this.themeConfig.brand &&
      this.themeConfig.brand.toLowerCase() === this.brand.XFARM.toLowerCase() &&
      this.isValidePage() &&
      !localStorage.getItem('mobileBannerClosed') &&
      (this.generalUtilsService.getMobileOS() === 'iOS' ||
        this.generalUtilsService.getMobileOS() === 'Android')
    ) {
      this.showOverlay = true;
    }
  }

  showMobileClosed() {
    localStorage.setItem('mobileBannerClosed', 'true');
    this.showOverlay = false;
  }

  isValidePage = () => {
    return !(
      window.location.href.includes('forgotPassword') ||
      window.location.href.includes('signUp') ||
      window.location.href.includes('completeSignUp') ||
      window.location.href.includes('validateUser') ||
      window.location.href.includes('resetPassword')
    );
  };
}
